import { render } from "./kba_step.vue?vue&type=template&id=a63c1a14"
import script from "./kba_step.vue?vue&type=script&lang=js"
export * from "./kba_step.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/docuseal-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__